/**
 * Header Class
 */
export class SearchFilters {

	oldFilters;

	filtersBox;

	filtersBg;

	filtersWrapper;

	buttonsWrapper;

	searchInput;

	accordions;

	postsContainer;

	loadMoreButton;

	tooltips;

	loader;

	body;


	/**
	 * Constructor
	 *
	 * @return {void}
	 */
	constructor() {

		this.filtersBox = document.querySelector( '.item-listing__filters' );
		this.filtersBg = document.querySelector( '.item-listing__filters .filters-bg' );
		this.filtersWrapper = document.querySelector( '.selected-filters-container' );
		this.buttonsWrapper = document.querySelector( '.selected-filters__items' );
		this.searchInput = document.querySelector( '.item-listing__search .c-input-group__post-search' );
		this.accordions = document.querySelectorAll( '.filters-accordion' );
		this.postsContainer = document.querySelector( '.posts-grid.container' );
		this.loadMoreButton = document.querySelector( '.js-load-more-posts-button' );
		this.tooltips = document.querySelectorAll( '.tax-tooltip' );
		this.loader = document.querySelector( '.js-posts-loader' );
		this.body = document.querySelector( 'body' );

	}

	initSearchfilters = () => {

		this.toggleFilters();
		this.toggleFiltersAccordion();
		this.applyFilters();
		this.removeFilters();
		this.submitSearchForm();
		this.toggleTooltip();
		this.loadMorePosts();

	}

	/**
	 * toggle filters
	 *
	 *
	 */
	toggleFilters = () => {

		const filtersBox = this.filtersBox;
		const openButton = document.querySelector( '.js-show-filters-button' );
		const closeButton = filtersBox.querySelectorAll( '.js-filters-close' );
		let scrollPosition = 0;

		if ( openButton && filtersBox ) {

			openButton.addEventListener( 'click', ( e ) => {

				e.preventDefault();

				scrollPosition = window.scrollY;
				this.body.style.top = `-${scrollPosition}px`;
				this.body.style.overflowY = 'visible';
				filtersBox.classList.add( 'filters-opened' );
				this.body.classList.add( 'body-no-scroll' );

				this.oldFilters = this.getSelectedFilters();

			} );

		}

		if ( closeButton.length > 0 ) {

			closeButton.forEach( close => {

				close.addEventListener( 'click', () => {

					setTimeout( () => {

						document.body.style.top = '';
						this.body.style.overflowY = 'hidden';
						window.scrollTo( { top: scrollPosition, behavior: 'instant' } );

					}, 0 );

					filtersBox.classList.remove( 'filters-opened' );
					this.body.classList.remove( 'body-no-scroll' );
					this.closeAllAccordions();
					this.closeAllTooltips();

				} )

			} );

		}

		// close filters by clicking on blured background
		if ( this.filtersBg ) {

			this.filtersBg.addEventListener( 'click', ( e ) => {

				if ( e.target === this.filtersBg ) {

					setTimeout( () => {

						document.body.style.top = '';
						window.scrollTo( { top: scrollPosition, behavior: 'instant' } );

					}, 0 );

					filtersBox.classList.remove( 'filters-opened' );
					this.body.classList.remove( 'body-no-scroll' );
					this.closeAllAccordions();
					this.closeAllTooltips();

				}

			} );

		}

	}

	/**
	 * toggle filters accordion
	 *
	 *
	 */
	toggleFiltersAccordion = () => {

		if ( this.accordions.length > 0 ) {

			this.accordions.forEach( accordion => {

				const accordionTitle = accordion.querySelector( '.js-filter-accordion' );

				if ( accordionTitle ) {

					accordionTitle.addEventListener( 'click', () => {

						accordion.classList.toggle( 'accordion-opened' );
						this.closeAllTooltips();

					} );

				}

			} );

		}

	}

	/**
	 * Close all accordions
	 *
	 */
	closeAllAccordions = () => {

		if ( this.accordions.length > 0 ) {

			this.accordions.forEach( acc => {

				acc.classList.remove( 'accordion-opened' )

			} );

		}

	}

	/**
	 * Get selected filters from filters checkboxes
	 *
	 * @return {array} array of selected filters
	 */
	getSelectedFilters = () => {

		const filters = document.querySelectorAll( '.js-tax-filter' );
		const selectedFilters = [];

		if( filters.length > 0 ) {

			filters.forEach( filter => {

				if ( filter.checked ) {

					const filterName = filter.getAttribute( 'name' )?.replace( '[]', '' );
					const filterText = filter.dataset.filtername;
					const filterValue = filter.getAttribute( 'value' );

					selectedFilters.push( { name: filterName, text: filterText, value: filterValue } );

				}

			} );

		}

		return selectedFilters;

	}

	/**
	 * Apply search filters on click 'Apply Filter' button
	 */
	applyFilters = () => {

		const applyButton = document.querySelector( '.js-filters-apply' );

		if ( this.filtersBox && applyButton ) {

			applyButton.addEventListener( 'click', ( e ) => {

				e.preventDefault();
				this.resetUrlParameters( false );

				const selectedFilters = this.getSelectedFilters();
				const url = new URL( location );

				selectedFilters.forEach( filter => {

					const filterName = filter.name;
					const filterValue = filter.value;
					const filterText = filter.text;

					// add search filters params to url.
					if ( url.searchParams.has( filterName ) ) {

						url.searchParams.append( filterName, filterValue );

					} else {

						url.searchParams.set( filterName, filterValue );

					}

					// add filter buttons.
					if ( ! this.isFilterButtonExists( filterName, filterValue ) ) {

						this.addFilterButton( filterName, filterValue, filterText );

					}

				} );

				// remove old filters buttons
				this.removeOldFiltersButtons( selectedFilters );


				// change url parameters.
				window.history.replaceState( {}, '', url );

				this.filtersBox.classList.remove( 'filters-opened' );
				this.body.classList.remove( 'body-no-scroll' );
				this.hideEmptyFiltersWrapper();
				this.closeAllAccordions();
				this.closeAllTooltips();
				this.loadNewPosts();

			} );

		}

	}

	/**
	 * Check if filter button for selected filter exists (on mobile)
	 *
	 * @param {string} filterName
	 * @param {string} filterValue
	 *
	 * @return {boolean} if button exists
	 */
	isFilterButtonExists = ( filterName, filterValue ) => {

		const existingFilterButton = document.querySelector( `.js-selected-filter-button[data-filter="${ filterName }"][data-filtervalue="${ filterValue }"]` );

		return existingFilterButton ? true : false;

	}

	/**
	 * Create filter buttton with image and text
	 * Display filter button
	 *
	 * @param {string} filterName
	 * @param {string} filterValue
	 * @param {string} filterText
	 */
	addFilterButton = ( filterName, filterValue, filterText ) => {

		const filtersButtonsContainer = this.filtersWrapper?.querySelector( '.selected-filters__items' );

		// create filter button.
		const filterButton = document.createElement( 'button' );
		const closeIcon = document.createElement( 'span' );
		const buttonText = document.createElement( 'span' );

		filterButton.type = 'button';
		filterButton.setAttribute( 'class', 'selected-filters__item c-button c-button--close js-selected-filter-button' );
		filterButton.dataset.filter = filterName;
		filterButton.dataset.filtervalue = filterValue;
		closeIcon.setAttribute( 'class', 'close-icon' );
		buttonText.textContent = filterText;
		filterButton.appendChild( closeIcon );
		filterButton.appendChild( buttonText );

		// display filters.
		this.filtersWrapper?.classList.add( 'has-active-filters' );
		filtersButtonsContainer.appendChild( filterButton );

	}

	/**
	 * Reset url parameters
	 *
	 * @param {boolean} $resetAll
	 */
	resetUrlParameters = ( $resetAll = true ) => {

		const clearUrl = window.location.href.replace( window.location.search, '' );

		if ( $resetAll ) {

			// change url parameters.
			window.history.pushState( {}, '', clearUrl );

		} else {

			// do not reset item-search filter
			const params = new URL( document.location ).searchParams;
			const itemSearchParam = params.get( 'item-search' );

			if ( itemSearchParam ) {

				const url = new URL( clearUrl );
				url.searchParams.set( 'item-search', itemSearchParam );

				// change url parameters.
				window.history.pushState( {}, '', url );

			} else {

				// change url parameters.
				window.history.pushState( {}, '', clearUrl );

			}


		}

	}

	/**
	 * Remove all filter buttons
	 * Uncheck all page filters inputs
	 * Clear search input value
	 * Reset url parameters
	 *
	 * @param {node} filtersWrapper
	 */
	resetFiltersButtons = ( filtersWrapper ) => {

		const selectedCheckboxes = document.querySelectorAll( '.js-tax-filter' );
		const filterButtons = document.querySelectorAll( '.js-selected-filter-button' );

		// remove all filters buttons.
		if ( filterButtons.length > 0 ) {

			filterButtons.forEach( ( button ) => {

				filtersWrapper?.querySelector( '.selected-filters__items' )?.removeChild( button );

			} )

		}

		// uncheck all page filters inputs.
		if ( selectedCheckboxes.length > 0 ) {

			selectedCheckboxes.forEach( ( filter ) => {

				filter.checked = false;

			} );

		}

		// clear search input value.
		if ( this.searchInput ) {

			this.searchInput.value = '';

		}

		// reset url parameters.
		this.resetUrlParameters();

		// hide filters wrapper.
		filtersWrapper?.classList.remove( 'has-active-filters' );

	}

	/**
	 * Remove single filter button on click
	 *
	 */
	removeFilters = () => {

		if ( this.filtersWrapper ) {

			this.filtersWrapper.addEventListener( 'click', ( e ) => {

				const filterButton = e.target.closest( '.js-selected-filter-button' );
				const resetButton = e.target.closest( '.js-reset-filters-button' );

				if ( filterButton ) {

					const url = new URL( location );
					const filterType = filterButton.dataset.filter;
					const filterValue = filterButton.dataset.filtervalue;

					if ( filterType === 'item-search' && this.searchInput ) {

						// remove search input filter.
						this.searchInput.value = '';
						url.searchParams.delete( filterType );

					} else {

						// uncheck filter checkbox.
						const input = document.querySelector( `input[name="${ filterType }[]"][value="${ filterValue }"]` );
						input.checked = false;

						// remove taxonomy filter from url.
						url.searchParams.delete( filterType, filterValue );

					}

					// remove filter button.
					if ( this.buttonsWrapper ) {

						this.buttonsWrapper.removeChild( filterButton );
						this.hideEmptyFiltersWrapper();

					}

					// change url parameters.
					window.history.pushState( {}, '', url );

				}

				if ( resetButton ) {

					this.resetFiltersButtons( this.filtersWrapper );

				}

				// reload posts
				this.loadNewPosts();

			} );

		}

	}

	/**
	 * Remove filter buttons, that are no longer needed
	 *
	 * @param {array} selectedFilters
	 */
	removeOldFiltersButtons = ( selectedFilters ) =>  {

		// remove filter buttons for filters that are not longer active
		if ( this.oldFilters.length > 0 ) {

			const buttonsToRemove = [];
			const newFiltersArr = selectedFilters.map( newFilter => {

				return JSON.stringify( newFilter );

			} )


			this.oldFilters.forEach( oldFilter => {

				if ( ! newFiltersArr.includes( JSON.stringify( oldFilter ) ) ) {

					buttonsToRemove.push( oldFilter );

				}


			} );

			if ( buttonsToRemove.length > 0 ) {

				buttonsToRemove.forEach( button => {

					const buttonToRemove = document.querySelector( `.js-selected-filter-button[data-filter="${ button.name }"][data-filtervalue="${ button.value }"]` );

					this.buttonsWrapper?.removeChild( buttonToRemove );

				} );

			}

		}

	}

	/**
	 * Hide filter buttons wrapper if empty
	 *
	 */
	hideEmptyFiltersWrapper = () => {

		if ( this.buttonsWrapper.childElementCount < 1 ) {

			// hide filters wrapper.
			this.filtersWrapper.classList.remove( 'has-active-filters' );

		}

	}

	/**
	 * Handle form submission
	 * Add/Remove search filter
	 *
	 */
	submitSearchForm = () => {

		const filtersForm = document.querySelector( '.item-listing__search' );

		if ( filtersForm && this.searchInput ) {

			filtersForm.addEventListener( 'submit', ( e ) => {

				e.preventDefault();

				const filterName = this.searchInput.getAttribute( 'name' );
				const filterValue = this.searchInput.value.replace( '<', '' ).replace( '>', '' );
				const url = new URL( location );
				const searchFilterButton = document.querySelector( `.js-selected-filter-button[data-filter="item-search"]` );
				const filtersButtonsContainer = this.filtersWrapper?.querySelector( '.selected-filters__items' );

				if ( filterName && filterValue ) {

					// add/replace search filter param to url.
					if ( url.searchParams.has( filterName ) ) {

						url.searchParams.set( filterName, filterValue );

					} else {

						url.searchParams.append( filterName, filterValue );

					}

					// remove search filter button if exists.
					if ( searchFilterButton && filtersButtonsContainer ) {

						filtersButtonsContainer.removeChild( searchFilterButton );

					}

					// add search filter button.
					this.addFilterButton( filterName, filterValue, filterValue );

				}

				// remove search filter param and button if search value is empty.
				if ( ! filterValue ) {

					const filterButton = document.querySelector( `.selected-filter-button[data-filter="${ filterName }"][data-filtervalue="${ filterValue }"]` );
					url.searchParams.delete( 'item-search' );

					filtersButtonsContainer?.removeChild( filterButton );
					this.hideEmptyFiltersWrapper();

				}

				// change url parameters.
				window.history.pushState( {}, '', url );

				// reload posts
				this.loadNewPosts();

			} );

		}

	}

	/**
	 * Load more posts on click
	 */
	loadMorePosts = () => {

		if ( this.loadMoreButton ) {

			this.loadMoreButton.addEventListener( 'click', () => {

				this.loadAjax( this.loadMoreButton );

			} )

		}

	}

	/**
	 * Reset posts list and load new posts
	 */
	loadNewPosts = () => {

		// remove all posts.
		this.removeAllChildNodes( this.postsContainer );

		if ( this.loadMoreButton ) {

			// set paged attriubte to 1.
			this.loadMoreButton.dataset.paged = 1;
			// load filtered posts.
			this.loadAjax( this.loadMoreButton );

		} else {

			// load filtered posts.
			this.loadAjax();

		}

	}

	/**
	 * Remove all childNodes of given parent
	 *
	 * @param {node} parent
	 */
	removeAllChildNodes = ( parent ) => {

		while ( parent.firstChild ) {

			parent.removeChild( parent.firstChild );

		}

	}

	/**
	 * Get new posts by ajax
	 *
	 * @param {node} loadMoreButton
	 */
	loadAjax = ( loadMoreButton = false ) => {

		const loadResultsVars = window.loadResultsVars
		const paged = loadMoreButton ? loadMoreButton.dataset.paged : 1;
		const filters = new URLSearchParams( window.location.search ).toString();

		if ( this.loader ) {

			this.loader.classList.add( 'visible' );
			this.loadMoreButton?.classList.add( 'button-hidden' );

		}

		fetch( loadResultsVars.url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams( {
				action: `load_results_${ loadResultsVars.post_type }`,
				sec: loadResultsVars.sec,
				paged: paged,
				filters: filters,
				postType: loadResultsVars.post_type,
			} ),
		} ).then( ( response ) => {

			return response.json();

		} ).then( ( response ) => {

			if ( response.data?.output !== undefined ) {

				const range = document.createRange();
				const fragment = range.createContextualFragment( response.data.output );

				this.postsContainer.appendChild( fragment );

				if ( loadMoreButton ) {

					loadMoreButton.dataset.paged = parseInt( paged ) + 1;

					if ( response.data?.end ) {

						loadMoreButton.classList.add( 'disabled' );

					} else {

						loadMoreButton.classList.remove( 'disabled' );

					}

				}

			}

		} ).catch( () => {

			// console.log( 'Error parsing JSON:', error );

		} ).finally( () => {

			if ( this.loader ) {

				this.loader.classList.remove( 'visible' );
				this.loadMoreButton?.classList.remove( 'button-hidden' );

			}

		} );

	}

	/**
	 * Toggle taxonomy tooltip on mobile
	 *
	 */
	toggleTooltip = () => {

		if ( this.tooltips.length > 0 ) {

			this.tooltips.forEach( ( tooltip ) => {

				this.setTooltipPosition( tooltip );

				// toggle tooltip on mobile
				tooltip.addEventListener( 'click', ( e ) => {

					e.preventDefault();

					const isMobile = window.matchMedia( '(max-width: 992px)' ).matches;

					if ( isMobile && e.target.closest( '.tax-tooltip' ) === tooltip ) {

						// hide all tooltips
						this.hideAllTooltips( tooltip );

						// show current tooltip
						tooltip.classList.toggle( 'tax-tooltip--visible' );

					}

				} )

			} )

		}

	}


	/**
	 * Set tooltip position if it extends beyond the screen on the right or left side.
	 *
	 * @param {node} tooltip
	 */
	setTooltipPosition = ( tooltip ) => {

		// tooltip on center
		const tooltipContent = tooltip.querySelector( '.tax-tooltip__content' );
		const mobilePadding = 20;
		const filtersWrapperWidth = document.querySelector( '.filters-content' )?.offsetWidth;
		const tooltipWidth = tooltipContent.offsetWidth;
		let tooltipPosLeft = tooltip.offsetLeft - mobilePadding;
		let afterPos = tooltip.offsetLeft - 16;

		// set tooltip position on mobile
		if ( tooltipContent ) {

			if ( ( filtersWrapperWidth - tooltip.offsetLeft ) < ( ( tooltipWidth / 2 ) + mobilePadding ) ) {

				tooltipPosLeft = ( tooltipWidth + mobilePadding ) - ( filtersWrapperWidth - tooltip.offsetLeft );
				afterPos = tooltipPosLeft + 4;

			} else if ( tooltipPosLeft > ( tooltipWidth / 2 ) ) {

				// tooltip on left
				tooltipPosLeft = 114;
				afterPos = 118;

			}

			tooltipContent.style.left = `-${ tooltipPosLeft }px`;
			tooltipContent.style.setProperty( '--tooltip-after-position', `${ afterPos }px` );

		}

	}

	/**
	 * Hide all campuses tooltips, except current one
	 *
	 * @param {node} tooltip
	 */
	hideAllTooltips = ( tooltip ) => {

		if ( this.tooltips.length > 0 ) {

			this.tooltips.forEach( ( singleTooltip ) => {

				const notRemove = tooltip === singleTooltip && tooltip.classList.contains( 'tax-tooltip--visible' );

				if ( ! notRemove ) {

					singleTooltip.classList.remove( 'tax-tooltip--visible' );

				}

			} );

		}

	}

	/**
	 * Close All tooltips
	 *
	 */
	closeAllTooltips = () => {

		if ( this.tooltips.length > 0 ) {

			this.tooltips.forEach( ( singleTooltip ) => {

				singleTooltip.classList.remove( 'tax-tooltip--visible' );

			} );

		}

	}

}